// const BASE_URL = 'http://localhost:8080'; 

const BASE_URL = 'https://xtragrowfoundation.org'; 


export { BASE_URL};